import { getPieveModelReasoningLevels } from '@shared/pieve/modelReasoning.js';
import toModelReasoningOptions from '@/lib/model/toModelReasoningOptions.js';

const getModelReasoningOptions = (modelId) => {
  return toModelReasoningOptions(getPieveModelReasoningLevels(modelId));
};

export default getModelReasoningOptions;
